// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/level-flight-pitch-correction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/level-flight-pitch-correction/level-flight-pitch-correction.js';

mount([g0]);
